export default __webpack_public_path__ + "static/media/proximanova-black.a9ea80c3.WOFF";